export const messages = {
    titles: {
        nav: 'Work Instructions',
        pageBannerSubtitle: 'Browse and edit work instructions',
        pageBannerTitle: 'Work Instructions',
    },
};
